<template>
	<l-modal
		:modal="modal"
		class="m-confirm"
	>
		<template
			v-slot:icon
			v-if="showIcon"
		>
			<c-icon
				v-if="!icon"
				class="icon"
				src="@icons/modalExclamation"
			/>
			<c-icon
				v-else
				class="icon"
				:src="icon"
			/>
		</template>

		<template v-slot:header>
			{{ title }}
		</template>

		<article class="m-confirm__content">
			<p class="text-l-medium">{{ text }}</p>
		</article>

		<template
			v-if="showReturnGlobalPosition"
			v-slot:buttons
		>
			<div
				class="m-confirm__buttons"
				:class="{ '--flex-direction-column': showReturnGlobalPosition }"
			>
				<c-button
					class="m-confirm__accept-button"
					v-if="showAcceptButton"
					data-testid="accept"
					secondary
					@click="confirm"
				>
					{{ acceptText || $t('ACTIONS.ACCEPT') }}
				</c-button>
				<a
					v-if="showReturnGlobalPosition"
					class="m-confirm__return text-m-medium"
					@click="
						this.$emit('close');
						$router.push({ name: 'home' });
					"
				>
					{{ $t('ACTIONS.GO_TO_VIEW', { view: $t('GLOBAL_POSITION') }) }}
				</a>
			</div>
		</template>
		<template
			v-else
			v-slot:buttons
		>
			<c-button
				v-if="showCancelButton"
				data-testid="cancel"
				secondary
				@click="cancel"
			>
				{{ cancelText || $t('ACTIONS.CANCEL') }}
			</c-button>
			<c-button
				v-if="showAcceptButton"
				data-testid="accept"
				secondary
				@click="confirm"
			>
				{{ acceptText || $t('ACTIONS.ACCEPT') }}
			</c-button>
		</template>
	</l-modal>
</template>

<script>
import LModal from '@layouts/l-modal';
import CButton from '@components/c-cbnk-button';
import CIcon from '@components/c-icon';

export default {
	name: 'm-confirm',

	components: {
		LModal,
		CButton,
		CIcon,
	},

	data() {
		return {
			value: null,
		};
	},

	props: {
		icon: { type: null },
		title: { type: String },
		text: { type: String },
		acceptText: { type: String },
		cancelText: { type: String },
		showCancelButton: {
			type: Boolean,
			default: true,
		},
		showAcceptButton: {
			type: Boolean,
			default: true,
		},
		showReturnGlobalPosition: {
			type: Boolean,
			default: false,
		},
		modal: {
			type: Boolean,
			default: false,
		},
		showIcon: {
			type: Boolean,
			default: true,
		},
	},

	methods: {
		cancel() {
			this.value = false;
			this.$emit('close');
		},

		confirm() {
			this.value = true;
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.m-confirm {
	--cbnk-bar-width: 140px;
	--cbnk-bar-border-size: 2px;
	--full-width: 662px;
}

.m-confirm__return {
	padding-top: 24px;
	color: RGB(var(--color-text-primary-dark-contrast));
}
.m-confirm__accept-button {
	min-width: 155px;
	width: 100%;
}

.m-confirm__buttons {
	display: flex;
	width: 100%;
	justify-content: stretch;
	align-items: center;
	flex-wrap: wrap;
	margin: 0 auto;
	flex: 1;
}

.--flex-direction-column {
	position: relative;
	width: 100%;
	flex-direction: column;
}
</style>
